import React from "react";
import {
  Box,
  Container,
  Typography,
  Button,
  Card,
  CardContent,
  CardActions,
} from "@mui/material";
import Grid from "@mui/material/Grid";  
import { useNavigate } from "react-router-dom";
import HomeData from "../utils/Helpers";

const Home = () => {
  const navigate = useNavigate();
  const cards = HomeData(navigate);

  return (
    <Box className="home-page">
      {/* Hero Section */}
      <section className="home-hero">
        <Container className="home-hero-container">
          <Typography variant="h3" className="home-hero-title">
            CodeLens
          </Typography>
          <Typography variant="body1" className="home-hero-subtitle">
            Connect your Git accounts, scan repositories, and view security & quality reports.
          </Typography>
          <div className="home-hero-cta">
            <Button
              className="home-btn primary"
              onClick={() => navigate("/github-connections")}
            >
              Connect GitHub
            </Button>
            <Button
              className="home-btn secondary"
              onClick={() => navigate("/bitbucket-connections")}
            >
              Connect Bitbucket
            </Button>
            <Button
              className="home-btn secondary"
              onClick={() => {
                const accessToken = localStorage.getItem("access_token");
                const idToken = localStorage.getItem("id_token");
                const url = `${process.env.REACT_APP_API_COMPLAINCE_REDIRECT}?accesstoken=${accessToken}&idtoken=${idToken}`;
                window.open(url, "_blank");
              }}
            >
              OpenShield
            </Button>
            <Button
              className="home-btn secondary"
              onClick={() => {
                const accessToken = localStorage.getItem("access_token");
                const idToken = localStorage.getItem("id_token");
                const url = `${process.env.REACT_APP_API_SECLENS_REDIRECT}?accesstoken=${accessToken}&idtoken=${idToken}`;
                window.open(url, "_blank");
              }}
            >
              SecLens
            </Button>
          </div>
        </Container>
      </section>

      {/* Action Cards */}
      <section className="home-actions">
        <Grid container spacing={3} className="home-actions-grid">
          {cards.map((card, idx) => (
            <Grid
              key={idx}
              size={{ xs: 12, md: 5 }}
              sx={{ display: "flex" }}
            >
              <Card className="home-card" sx={{ width: "100%" }}>
                <CardContent className="home-card-content">
                  <div className="home-card-icon">{card.icon}</div>
                  <Typography variant="h6" className="home-card-title">
                    {card.title}
                  </Typography>
                  <Typography className="home-card-text">
                    {card.text}
                  </Typography>
                </CardContent>
                <CardActions className="home-card-actions">
                  {card.buttons.map((btn, bIdx) => (
                    <Button
                      key={bIdx}
                      className="home-btn small"
                      onClick={btn.action}
                    >
                      {btn.label}
                    </Button>
                  ))}
                </CardActions>
              </Card>
            </Grid>
          ))}
        </Grid>
      </section>
    </Box>
  );
};

export default Home;
